// const { useLocation } = 'react-router-dom';
function useQuery() {
  // const location = useLocation();
  return new URLSearchParams(window.location.search);
}

export default useQuery;
